import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Use `TrackUsageContextStandalone` instead.
 */
export const TrackUsageContext = /*#__PURE__*/createContext(() => {});

/**
 * @deprecated Use `useTrackUsageContextStandalone` instead.
 */
export const useTrackUsageContext = () => useContext(TrackUsageContext);

/**
 * @deprecated Use `TrackUsageProvider` instead and pass in the tracker from the app.
 */
export const usageTrackerAdapter = tracker => config => tracker && tracker.track(config.key, config.properties);

/**
 * Tracking for standalone events. This requires events to be created in the Usage Library.
 * See migration guide https://product.hubteam.com/docs/usage-tracking-manual/docs/guides/migrating-from-events-yaml.html
 */

const TrackUsageContextStandalone = /*#__PURE__*/createContext(undefined);
export const useTrackUsageContextStandalone = () => {
  const tracker = useContext(TrackUsageContextStandalone);
  if (!tracker) {
    throw new Error('TrackUsageContextStandalone not found');
  }
  return tracker;
};
export const TrackUsageProvider = ({
  children,
  tracker
}) => {
  return (
    /*#__PURE__*/
    // TODO: remove deprecated tracking when migration to standalone is complete
    _jsx(TrackUsageContext.Provider, {
      value: usageTrackerAdapter(tracker),
      children: /*#__PURE__*/_jsx(TrackUsageContextStandalone.Provider, {
        value: tracker === null || tracker === void 0 ? void 0 : tracker.clone({
          standalone: true
        }),
        children: children
      })
    })
  );
};
TrackUsageProvider.displayName = 'TrackUsageProvider';